// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1Rv1W","additionalInfo":"AgreementModal_additionalInfo__2r0i0"};